// Deterministic org color-coding — mirrors the mockup's workspace-avatar hashing
// (see mockup-app-design.html). The same org name always maps to the same accent,
// so the workspace switcher is recognizable at a glance.
import type { CSSProperties } from 'react';

export interface OrgColor {
  bg: string;
  border: string;
  text: string;
}

const PALETTE: OrgColor[] = [
  { bg: 'rgba(181,232,74,.18)', border: 'rgba(181,232,74,.35)', text: '#b5e84a' }, // lime
  { bg: 'rgba(96,165,250,.18)', border: 'rgba(96,165,250,.35)', text: '#60a5fa' }, // blue
  { bg: 'rgba(167,139,250,.18)', border: 'rgba(167,139,250,.35)', text: '#a78bfa' }, // violet
  { bg: 'rgba(249,115,22,.18)', border: 'rgba(249,115,22,.35)', text: '#f97316' }, // orange
  { bg: 'rgba(236,72,153,.18)', border: 'rgba(236,72,153,.35)', text: '#ec4899' }, // pink
  { bg: 'rgba(34,211,238,.18)', border: 'rgba(34,211,238,.35)', text: '#22d3ee' }, // cyan
];

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function getOrgColor(name?: string | null): OrgColor {
  return PALETTE[hashString(name || '') % PALETTE.length];
}

/** Convenience: inline style for a colored org/workspace avatar. */
export function orgAvatarStyle(name?: string | null): CSSProperties {
  const c = getOrgColor(name);
  return { backgroundColor: c.bg, color: c.text, border: `1px solid ${c.border}` };
}
